export const SET_TRANSACTIONS_FILTER = 'SET_TRANSACTIONS_FILTER';

export const SET_PAYOUTS_FILTER = 'SET_PAYOUTS_FILTER';
export const SET_INVOICES_FILTER = 'SET_INVOICES_FILTER';

export const SET_BLOCKED_FILTER = 'SET_BLOCKED_FILTER';
